<template>
	<v-btn-toggle
		:value="value"
		:active-class="activeClass"
		:color="color"
		:dense="dense"
		:mandatory="mandatory"
		:multiple="multiple"
		v-bind="$attrs"
		v-on="unhandled_events"
		@change="on_change"
	>
		<slot></slot>
	</v-btn-toggle>
</template>

<script>
export default {
	inheritAttrs: false,
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: [String, Number, Boolean, Array],
		activeClass: String,
		color: String,
		dense: Boolean,
		mandatory: Boolean,
		multiple: Boolean
	},
	computed: {
		unhandled_events() {
			const { change, ...listeners } = this.$listeners;
			return listeners;
		}
	},
	methods: {
		on_change(value) {
			this.$emit('change', value);
		}
	}
};
</script>
